import React from 'react'
import { Box, Typography } from '@mui/material'

const NotFound = () => {
  return (
    <Box component="main" sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100vh",
        gap: "20px"
    }}>
        <Typography variant='h1'>404</Typography>
        <Typography variant='h3'>Not found</Typography>
        <Typography variant="subtitle1">Check URL and try again</Typography>
    </Box>
  )
}

export default NotFound
